import { computed } from 'vue';

/**
 * Composable for checking the current application environment
 *
 * @returns Object with environment check computed properties
 * @example
 * const { isStaging, isProduction } = useEnvironment();
 *
 * // In template
 * <div v-if="isStaging">Staging-only feature</div>
 */
export const useEnvironment = () => {
   const config = useRuntimeConfig();

   const isStaging = computed(() => config.public.siteEnv === 'staging');
   const isProduction = computed(() => config.public.siteEnv === 'production');
   const isDevelopment = computed(() => config.public.siteEnv === 'development');

   return {
      isStaging,
      isProduction,
      isDevelopment,
      siteEnv: config.public.siteEnv
   };
};
